import { useCallback, useEffect, useState } from 'react';
import SessionStorageService from '../../../services/SessionStorageService';
import { entidadeUser, get } from '../../../services/utils';
import styles from '../../../styles/ocorrencia/ConsultarOcorrenciaForm.module.scss'
import { GET_OCORRENCIA, AUTH_LOCALSTORAGE, PESQUISAR_DOCUMENTOS_OCORRENCIA, CURRENT_TIMEZONE, EPSG_MAP, EPSG_OCORRENCIA_DISPLAY } from '../../../utils/constants';
import { useOcorrenciaStore } from '../../../stores/ocorrencias';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import clsx from 'clsx';
import { Grid, GridColumn, GridPageChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
import moment from 'moment'
import "moment-timezone"
import React from 'react';
import { textAlign } from 'html2canvas/dist/types/css/property-descriptors/text-align';
import proj4 from 'proj4';

const getOcorrencia = async (data: any) =>
await get<any, any>(`${GET_OCORRENCIA}/` + data)
const getDocumentosByOcorrencia = async (data: any) =>
await get<any, any>(`${PESQUISAR_DOCUMENTOS_OCORRENCIA}/` + data)

type PageState = {
  skip: number
  take: number
}

const initialDataState: PageState = { skip: 0, take: 10 }

const detecaoDaOcorrência = {
  1: "Aviso/Chamada",
  2: "Visita Regular"
};

export function OcorrenciaTerrenoConclusao({ props, selectedOcorrenciaResult }: any) {
    const userLocal = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}');
    const [coordenadasFormatadas, setCoordenadasFormatadas] = useState<string>('');
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState<PageState>(initialDataState)
    const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
    >()
    const getDocumentosByOcorrencia = async (data: any) =>
    await get<any, any>(`${PESQUISAR_DOCUMENTOS_OCORRENCIA}/` + data)

    
    const _getDocumentosByOcorrencia = async (id?: any) => {
      try {
        postMessage({ type: 'showLoader' }, '*')

        const result = await getDocumentosByOcorrencia(id)

        if (Array.isArray(result)) {
          setData(result)
        }
      } catch (error) {
        setData([])
      } finally {
        postMessage({ type: 'hideLoader' }, '*')
      }

    }

    const _formatCoords = (coord_x: string, coord_y: string) => {
        const coordenada_x = parseFloat(coord_x);
        const coordenada_y = parseFloat(coord_y);
        const latLong = proj4(EPSG_MAP, EPSG_OCORRENCIA_DISPLAY, [coordenada_x, coordenada_y]);
        if (latLong && latLong.length > 0) {
            return `${latLong[0].toFixed(0)}, ${latLong[1].toFixed(0)}`;
        }
        return '---, ---';
    }

    useEffect(() => {
      if (selectedOcorrenciaResult?.id) {
        _getDocumentosByOcorrencia(selectedOcorrenciaResult?.id);
        }
        if (selectedOcorrenciaResult?.coord_x && selectedOcorrenciaResult?.coord_y) {
          setCoordenadasFormatadas(_formatCoords(selectedOcorrenciaResult.coord_x, selectedOcorrenciaResult.coord_y));
        }
    }, [selectedOcorrenciaResult]);

    const handlePageChange = (event: GridPageChangeEvent) => {
      const targetEvent = event.targetEvent as PagerTargetEvent
      const take = event.page.take
    
      if (targetEvent.value) {
        setPageSizeValue(targetEvent.value)
      }
      setPage({
        ...event.page,
        take,
      })
    }
    const valoresConclusao = SessionStorageService.getItem("valoresResumo");

    
    const availableData = data.slice();
    const initialData = availableData.splice(0, 20);

    const pessoasEmRisco = "Sim: " + (valoresConclusao?.numPessoasEmRisco ? valoresConclusao?.numPessoasEmRisco + ' pessoas' : '');
    
    const [gridData, setGridData] = React.useState(initialData);

    const scrollHandler = (event: { nativeEvent: any; }) => {
      const ScroolLength = 10;
      const e = event.nativeEvent;
      if (
        e.target.scrollTop + ScroolLength >=
        e.target.scrollHeight - e.target.clientHeight
      ) {
        const moreData = availableData.splice(0, ScroolLength);
        if (moreData.length > 0) {
          setGridData((oldData) => oldData.concat(moreData));
        }
      }
    };

    //  TIPOLOGIAS
    const InstabilidadeArribas = valoresConclusao?.instabiladeArribas;
    const ErosaoRecuso = valoresConclusao?.erosaoRecuo;
    const DanosEstrutura = valoresConclusao?.protecaoDefesa;
    const validarTipologiasPreenchidas = InstabilidadeArribas || ErosaoRecuso || valoresConclusao?.galgamento || DanosEstrutura;

    //  CAUSAS
    const validarCausasPreenchidas = valoresConclusao?.naoSabe || valoresConclusao?.tempestade || valoresConclusao?.sismos || valoresConclusao?.outras;

    //  MEDIDAS MITIGAÇÃO
    const MedidaImediata = valoresConclusao?.sinalizacao === 2 || valoresConclusao?.delimitacao === 2 || valoresConclusao?.saneamento === 2 || valoresConclusao?.reforco === 2;
    const MedidaAdotar = valoresConclusao?.sinalizacao === 1 || valoresConclusao?.delimitacao === 1 || valoresConclusao?.saneamento === 1 || valoresConclusao?.reforco === 1;
    const validarMedidasPreenchidas = valoresConclusao?.medidasMetigacao || MedidaImediata || MedidaAdotar;

  return (
    <div className={`${styles.formResumo} ${styles.removeScrollDuplicado}`}>
      <fieldset>  {/*Fieldset Registo */}
        <legend>
          <span className={styles.fieldsetTitulo}>Registo</span>
        </legend>

        <div className={styles.DivCamposConclusao}>
          <div>
            <div>
              <span className={styles.nomeCamposConclusao}>ID</span>
            </div>
            <div className='LastCampo'>
              <span className={styles.resultadoCamposConclusao}>{valoresConclusao?.id} </span>
            </div>
          </div>
          <div>
            <span className={styles.nomeCamposConclusao}>Data / Hora do registo</span>
            <div className="LastCampo">
              <span className={styles.resultadoCamposConclusao}>
                {valoresConclusao?.dataHoraRegistro ? moment.utc(valoresConclusao?.dataHoraRegistro).tz(CURRENT_TIMEZONE).format('YYYY-MM-DD HH:mm:ss') : undefined}
              </span>
            </div>
          </div>
          <div>
            <div>
              <span className={styles.nomeCamposConclusao}>Técnico</span>
            </div>
            <div className='LastCampo'>
              <span className={styles.resultadoCamposConclusao}>{valoresConclusao?.tecnico} </span>
            </div>
          </div>
          <div>
            <div>
              <span className={styles.nomeCamposConclusao}>Entidade</span>
            </div>
            <div className='LastCampo'>
              
              <span className={styles.resultadoCamposConclusao}>{valoresConclusao?.entidade ? valoresConclusao?.entidade?.nome : entidadeUser} </span>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>  {/*Fieldset Identificação */}
         <legend>
          <span className={styles.fieldsetTitulo}>Identificação</span>
         </legend>
          <div className={styles.DivCamposConclusao}>
                <span className={styles.nomeCamposConclusao}>Data / Hora da ocorrência</span>
                <div className="LastCampo">
                  <span className={styles.resultadoCamposConclusao}>
                    {valoresConclusao?.dataHoraOcorrencia ? moment.utc(valoresConclusao?.dataHoraOcorrencia).tz(CURRENT_TIMEZONE).format('YYYY-MM-DD HH:mm:ss') : 'Data indeterminada'  }         
                  </span>
                </div>
            <div>
              <span className={styles.nomeCamposConclusao}>Deteção da ocorrência </span>
            </div>
            <div>
            {valoresConclusao?.detecaoOcorrencia === 1 ? (
                <span className={styles.resultadoCamposConclusao}>Aviso/Chamada</span>
              ) : valoresConclusao?.detecaoOcorrencia === 2 ? (
                <span className={styles.resultadoCamposConclusao}>Visita Regular</span>
              ) : null}
            </div>
         </div>
      </fieldset>

      <fieldset>  {/*Fieldset Localização */}
        <legend>
          <span className={styles.fieldsetTitulo}>Localização</span>
        </legend>

        <div className={styles.DivCamposConclusao}>            
          <div className='LastCampo' style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flex: 1 }}>
              <div>
                <span className={styles.nomeCamposConclusao}>Distrito </span>
              </div>
              <div>
                <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.distrito?.nome ?? ''}</span>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div>
                <span className={styles.nomeCamposConclusao}>Concelho </span>
              </div>
              <div>
                <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.concelho?.nome ?? ''}</span>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div>
                <span className={styles.nomeCamposConclusao}>Freguesia</span>
              </div>
              <div>
                <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.freguesia?.nome ?? ''}</span>
              </div>
            </div>      
          </div>
        <div className='LastCampo' style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flex: 1 }}>
            <div>
              <span className={styles.nomeCamposConclusao}>Capitania </span>
            </div>
            <div>
              <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.capitania?.nome}</span>
            </div>
          </div>
            <div style={{ flex: 1 }}>
              <div>
                <span className={styles.nomeCamposConclusao}>Praia </span>
              </div>
              <div>
                <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.praia?.nome ?? ''}</span>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div>
                <span className={styles.nomeCamposConclusao}>Local</span>
              </div>
              <div>
                <span className={styles.resultadoCamposConclusao}>{selectedOcorrenciaResult?.ref_localizacao}</span>
              </div>
            </div>          
          </div>
          <div>
            <div>
              <span className={styles.nomeCamposConclusao}>Longitude e latitude (ETRS89/PT-TM06)</span>
            </div>
            <div>
              <span className={styles.resultadoCamposConclusao}>{coordenadasFormatadas ?? ''}</span>
            </div>
          </div>
        </div>
      </fieldset>

      { validarTipologiasPreenchidas && (
        <fieldset>  {/*Fieldset Tipologia */}
          <legend>
            <span className={styles.fieldsetTitulo}>Tipologia</span>
          </legend>
          <div className={styles.DivCamposConclusao}>
            <div>
              {InstabilidadeArribas && (
                <div>
                  <span className={styles.resultadoCamposConclusao}>• Instabilidades em arribas</span>
                  <div className="LastCampo">
                    {valoresConclusao?.movimentoMassa ?
                      <div>
                        <span className={clsx(styles.resultadoCamposConclusao, styles.espacamentoResumo)}>Movimento de massa de vertente (MMV):&nbsp;
                        </span>
                        <span className={styles.resultadoCamposConclusao}>
                          Alcance máximo do depósito/detritos:&nbsp;
                          {valoresConclusao?.tip_mmv_alcance_deposito ? valoresConclusao?.tip_mmv_alcance_deposito + "m" : ""}
                        </span>
                      </div>
                    : ""}

                    {valoresConclusao?.fendaTracao ?
                      <div>
                        <span className={clsx(styles.resultadoCamposConclusao, styles.espacamentoResumo)}>Fenda de tração com abertura visível</span>
                      </div>
                    : ""}
                  </div>
                </div>
              )}

              {ErosaoRecuso && (
                <div>
                  <span className={styles.resultadoCamposConclusao}>• Erosão/Recuo da linha da costa</span>
                  <div className="LastCampo">
                    {valoresConclusao?.escarpamento ?
                      <div>
                        <span className={clsx(styles.resultadoCamposConclusao, styles.espacamentoResumo)}>Escarpamento da duna:&nbsp;
                          Altura máxima da escarpa:&nbsp;
                          {valoresConclusao?.tip_altura_maxima_escarpa ? valoresConclusao?.tip_altura_maxima_escarpa + "m" : ""}
                        </span>
                      </div>
                    : ""}

                    {valoresConclusao?.rebaixamento ?
                      <div>
                        <span className={clsx(styles.resultadoCamposConclusao, styles.espacamentoResumo)}>Rebaixamento da praia:&nbsp;
                          Altura máxima da praia:&nbsp;
                          {valoresConclusao?.tip_reb_praia_altura_max ? valoresConclusao?.tip_reb_praia_altura_max + "m" : ""}
                        </span>
                      </div>
                    : ""}
                  </div>
                </div>
              )}

              {valoresConclusao?.galgamento ?
                <div>
                  <span className={styles.resultadoCamposConclusao}>• Galgamento costeiro</span>
                  <div className="LastCampo"> 
                  <span className={clsx(styles.resultadoCamposConclusao, styles.espacamentoResumo)}>Alcance máximo de água /detritos:&nbsp;
                      {valoresConclusao?.tip_galg_cost_alcance_max ? valoresConclusao?.tip_galg_cost_alcance_max + "m" : ""}
                    </span>
                  </div>
                </div>
              : ""}
              
              {DanosEstrutura && (
                <div>
                  <span className={styles.resultadoCamposConclusao}>• Danos em estruturas de proteção/defesa costeira</span>
                  <div className="LastCampo">
                    <div>
                      <span className={styles.resultadoCamposConclusao}>
                        <span className={styles.espacamentoResumo}>{valoresConclusao?.estruturaAderente ? "Estrutura aderente" : ""}</span><br/>
                        <span className={styles.espacamentoResumo}>{valoresConclusao?.esporao ? "Esporão/Quebra-mar" : ""}</span><br/>
                        <span className={styles.espacamentoResumo}>{valoresConclusao?.protecaoEstabilizacao ? "Estrutura de proteção/estabilização de arriba" : ""}</span>
                      </span>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </fieldset>
      )}

      <fieldset>  {/* Fieldset Consequências */}
        <legend>
          <span className={styles.fieldsetTitulo}>Consequências</span>
        </legend>
        <div className={styles.DivCamposConclusao}>
          <div> {/* Pessoas em Risco  */}
            <div>
              <span className={styles.nomeCamposConclusao}>Pessoas em risco</span>
            </div>
            <div className='LastCampo'>
              {valoresConclusao?.pessoaEmRisco === 0 || valoresConclusao?.pessoaEmRisco === undefined  ? (
                  <span className={styles.resultadoCamposConclusao}>Não</span>
                ) : valoresConclusao?.pessoaEmRisco === 1 ? (
                  <span className={styles.resultadoCamposConclusao}>{pessoasEmRisco}</span>
                ) : valoresConclusao?.pessoaEmRisco === 2 ? (
                  <span className={styles.resultadoCamposConclusao}>Não sabe</span>
                  ) : null}
            </div>
          </div>

          <div> {/* Danos em Edificações  */}
            <div className='LastCampo'>
              <div>
                <div>
                  <span className={styles.nomeCamposConclusao}>Danos em edificações</span>
                </div>
              </div>

              <div>
              <span className={styles.resultadoCamposConclusao}>
                {valoresConclusao.danosEdificacoesOption === 0 || !valoresConclusao?.danosEdificacoesOption 
                  ? "Não"
                  : valoresConclusao.danosEdificacoesOption === 2
                  ? "Não sabe/Não aplicável"
                  : ""}
              </span>
            </div>

            {valoresConclusao.danosEdificacoesOption === 1 && (
              <>
                {valoresConclusao?.fruicaoUsoPublico && (
                  <div>
                    <span className={styles.resultadoCamposConclusao}>
                      Danos em áreas construídas de fruição/uso público
                    </span>
                  </div>
                )}

                {valoresConclusao?.danosEdificacoes && (
                  <div>
                    <span className={styles.resultadoCamposConclusao}>Danos em edifícios</span>
                  </div>
                )}

                {valoresConclusao?.outrosDanos && (
                  <div>
                    <span className={styles.resultadoCamposConclusao}>
                      Outros danos: {valoresConclusao?.outrosDanosDescricao}
                    </span>
                  </div>
                )}
              </>
            )}
            </div>

            <div className='LastCampo'>     
              <div>
                <span className={styles.nomeCamposConclusao}>Danos em sistemas naturais</span>
              </div>
              <div>
                {valoresConclusao?.sistemasNaturais === 0 || valoresConclusao?.sistemasNaturais === undefined ? (
                  <span className={styles.resultadoCamposConclusao}>Não</span>
                ) : valoresConclusao?.sistemasNaturais === 1 ? (
                  <span className={styles.resultadoCamposConclusao}>
                    Sim{valoresConclusao?.descricaoDanosSistemasNaturais && `: ${valoresConclusao.descricaoDanosSistemasNaturais}`}
                  </span>
                ) : valoresConclusao?.sistemasNaturais === 2 ? (
                  <span className={styles.resultadoCamposConclusao}>Não sabe</span>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      { validarCausasPreenchidas && (
        <fieldset>  {/*Fieldset Causas */}
          <legend>
            <span className={styles.fieldsetTitulo}>Causas da ocorrência</span>
          </legend>
          <div className={styles.DivCamposConclusao}>
            {valoresConclusao?.naoSabe ?
              <div className="LastCampo">
                <span className={styles.resultadoCamposConclusao}>• Não sabe/Não aplicável</span>
              </div>
            : ""}

            {valoresConclusao?.tempestade ?
              <div>
                <div className="LastCampo">
                  <span className={styles.resultadoCamposConclusao}>• Tempestade: </span>
                  <span className={styles.resultadoCamposConclusao}>
                    {valoresConclusao?.descricaoTempestade ? valoresConclusao?.descricaoTempestade : ""}
                  </span>
                </div>
              </div>
            : ""}

            {valoresConclusao?.sismos ? 
              <div className="LastCampo">
                <span className={styles.resultadoCamposConclusao}>• Sismos</span>
              </div>
            : ""}

            {valoresConclusao?.outras ?
              <div>
                <div className="LastCampo">
                  <span className={styles.resultadoCamposConclusao}>• Outras: </span>
                  <span className={styles.resultadoCamposConclusao}>
                    {valoresConclusao?.descricaoOutras ? valoresConclusao?.descricaoOutras : ""}
                  </span>
                </div>
              </div>
            : ""}
          </div>
        </fieldset>
      )}

      { validarMedidasPreenchidas ?
        <fieldset>  {/*Fieldset Medidas Mitigação */}
          <legend>
            <span className={styles.fieldsetTitulo}>Medidas de mitigação do risco</span>
          </legend>
          <div className={styles.DivCamposConclusao}>
            { valoresConclusao?.medidasMetigacao ?
              <div>
                <span className={styles.nomeCamposConclusao}>Medidas de mitigação</span>
                <div className="LastCampo">
                  <div>
                    {valoresConclusao?.medidasMetigacao === 0 ? (
                      <span className={styles.resultadoCamposConclusao}>Não</span>
                    ) : valoresConclusao?.medidasMetigacao === 1 ? (
                      <span className={styles.resultadoCamposConclusao}>Sim</span>
                    ) : valoresConclusao?.medidasMetigacao === 2 ? (
                      <span className={styles.resultadoCamposConclusao}>Não sabe</span>
                    ) : null}
                  </div>
                </div>
              </div>
            : ""}

            { MedidaImediata ?
              <div>
                  <span className={styles.nomeCamposConclusao}>Medidas imediatas</span>
                  <div className="LastCampo">
                    <div>
                      {valoresConclusao?.sinalizacao === 2 ? (
                        <span className={styles.resultadoCamposConclusao}>Sinalização aviso</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.delimitacao === 2 ? (
                        <span className={styles.resultadoCamposConclusao}>Delimitação da área de risco</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.saneamento === 2 ? (
                        <span className={styles.resultadoCamposConclusao}>Saneamento de blocos</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.reabilitacao === 2 ? (
                        <span className={styles.resultadoCamposConclusao}>Reabilitação de obra de proteção</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.reforco === 2 ? (
                        <span className={styles.resultadoCamposConclusao}>Reforço artificial de emergência</span>
                      ) : null}
                    </div>
                  </div>
              </div>
            : ""}

            { MedidaAdotar ?
              <div>
                  <span className={styles.nomeCamposConclusao}>Medidas a adotar</span>
                  <div className="LastCampo">
                    <div>
                      {valoresConclusao?.sinalizacao === 1 ? (
                        <span className={styles.resultadoCamposConclusao}>Sinalização interdição</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.delimitacao === 1 ? (
                        <span className={styles.resultadoCamposConclusao}>Interdição da área de risco</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.saneamento === 1 ? (
                        <span className={styles.resultadoCamposConclusao}>Saneamento de reperfilamento</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.reabilitacao === 1 ? (
                        <span className={styles.resultadoCamposConclusao}>Reabilitação de obra de estabilização</span>
                      ) : null}
                    </div>
                    <div>
                      {valoresConclusao?.reforco === 1 ? (
                        <span className={styles.resultadoCamposConclusao}>Alimentação artificial de emergência</span>
                      ) : null}
                    </div>
                  </div>
              </div>
            : ""}
          </div>
        </fieldset>
      : ""}

      { valoresConclusao?.observacao && (
        <fieldset>  {/*Fieldset Observações */}
          <legend>
            <div>
              <span className={styles.fieldsetTitulo}>Observações</span>
            </div>
          </legend>
          <div className={styles.DivCamposConclusao}>
            <span className={styles.resultadoCamposConclusao}>{valoresConclusao?.observacao ? valoresConclusao?.observacao : ""}</span>
          </div>
        </fieldset>
      )}

      <fieldset>  {/*Fieldset Anexos */}
        <legend>
          <span className={styles.fieldsetTitulo}>Anexos</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
          <div className={styles.scrollableArea}>
            <Grid
              className={'customGrid'}
              data={data?.slice(page.skip, page.take + page.skip)}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              onScroll={scrollHandler}
              fixedScroll={true}
              rowHeight={50}
              total={data.length}
              skip={page.skip}
              take={page.take}
              onPageChange={handlePageChange}
            >

              {/* coluna vazia necessária para mobile */}
              <GridColumn field='' title='' width="0px" className={styles.centerAlign} />
              <GridColumn field='id' title='ID Documento' width="100px" className={styles.centerAlign} />

              <GridColumn field="tipoRecurso.designacao" title="Tipo" width="170px" className={styles.centerAlign} />

              <GridColumn field="titulo" title="Título" width="170px" cell={(props) => (
                <td style={{textAlign: "center"}}>
                  {props.dataItem.titulo ? props.dataItem.titulo: ""}
                </td>
              )}/>
            </Grid>
          </div>
        </div>
      </fieldset>
    </div>
  )
}
